import {
  type CreateAdditionalDiscountRequest,
  type AdditionalDiscountDetail,
  AdditionalDiscountDetailSchema,
  type AdditionalDiscountListQuery,
  type AdditionalDiscountListResponse,
  AdditionalDiscountListResponseSchema,
  type UpdateAdditionalDiscountRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listAdditionalDiscounts = async (
  query: AdditionalDiscountListQuery,
): Promise<AdditionalDiscountListResponse> => {
  const { data } = await apiClient.get<unknown>('/additional-discounts', { params: query });
  return AdditionalDiscountListResponseSchema.parse(data);
};

export const getAdditionalDiscount = async (id: string): Promise<AdditionalDiscountDetail> => {
  const { data } = await apiClient.get<unknown>(`/additional-discounts/${id}`);
  return AdditionalDiscountDetailSchema.parse(data);
};

export const createAdditionalDiscount = async (
  payload: CreateAdditionalDiscountRequest,
): Promise<AdditionalDiscountDetail> => {
  const { data } = await apiClient.post<unknown>('/additional-discounts', payload);
  return AdditionalDiscountDetailSchema.parse(data);
};

export const updateAdditionalDiscount = async (
  id: string,
  payload: UpdateAdditionalDiscountRequest,
): Promise<AdditionalDiscountDetail> => {
  const { data } = await apiClient.patch<unknown>(`/additional-discounts/${id}`, payload);
  return AdditionalDiscountDetailSchema.parse(data);
};

export const deleteAdditionalDiscount = async (id: string): Promise<void> => {
  await apiClient.delete(`/additional-discounts/${id}`);
};
